import { render, staticRenderFns } from "./InvoiceBody.vue?vue&type=template&id=1298bd2f&scoped=true&"
import script from "./InvoiceBody.vue?vue&type=script&lang=ts&"
export * from "./InvoiceBody.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceBody.vue?vue&type=style&index=0&id=1298bd2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298bd2f",
  null
  
)

export default component.exports